import { reactive } from "vue";
import { api } from "~/api";
import { PasswordReissue } from "~/api/auth/commands/PasswordReissue";
import { ValidateCodePasswordReissue } from "~/api/auth/commands/ValidateCodePasswordReissue";
class Store {
    mailAddress = "";
    authCode = "";
    authLimit = 0;
    async passwordReissue(model) {
        this.mailAddress = model.mailAddress;
        let result = await api.auth.passwordReissue(new PasswordReissue(model));
        this.authLimit = result.limit;
    }
    async validateCodePasswordReissue(model) {
        this.authCode = model.authCode;
        let result = await api.auth.validateCodePasswordReissue(new ValidateCodePasswordReissue(this.mailAddress, this.authCode));
        return result;
    }
    clear() {
        this.mailAddress = "";
        this.authCode = "";
        this.authLimit = 0;
    }
}
export let store = reactive(new Store());
